module.exports = __webpack_public_path__ + "static/media/admin.b6b2cc1b.webp";